<script lang="ts">
	import { Picture } from "@ishavskraft/shared";
	import { telDial } from "#lib/utils/telDial.js";
	import type { AvtalePersonBanner } from "#lib/types/avtale.js";
	import { PortableText } from "@portabletext/svelte";

	interface Props {
		personBanner: AvtalePersonBanner;
	}
	let { personBanner }: Props = $props();
</script>

<div class="mx-edge-x mb-8 tablet:mb-11 bg-[--aurora-30] rounded-xl p-4">
	<div class="bg-white rounded-xl p-8 flex flex-col laptop:flex-row gap-8 items-center">
		<!--Text -->
		<div class="flex-1">
			<h2>{personBanner.title}</h2>
			<PortableText value={personBanner.description} />
		</div>
		<!-- image and contact -->
		<div
			class="flex flex-row items-center text-center shrink-0 gap-2"
			style="--picture-width: 100%;"
		>
			{#if personBanner.image && personBanner.image.src}
				<div class="w-[150px] h-[150px] mb-4">
					<Picture
						src={personBanner.image.src}
						srcset={personBanner.image.srcset}
						srcsetWebp={personBanner.image.srcsetWebp}
						alt={personBanner.image.alt}
						width={150}
						height={150}
						circle
					/>
				</div>
			{/if}
			<div class="flex items-start flex-col">
				<p class="font-bold mb-0">{personBanner.name}</p>
				<p class="font-bold mt-0">{personBanner.role}</p>
				<p class="mt-2">
					<a href="tel:{telDial(personBanner.contact_number)}">{personBanner.contact_number}</a>
					<span class="mx-1">/</span>
					<a href={`mailto:${personBanner.contact_email}`}>{personBanner.contact_email}</a>
				</p>
			</div>
		</div>
	</div>
</div>
